import { DEFAULT_LOCALE, type Locale } from '@/i18n/locale';

/**
 * "منذ ٣ ساعات" — what `next-intl`'s formatter produced for the notification list.
 *
 * `Intl.RelativeTimeFormat` is the platform's own, and it is what `next-intl`
 * was wrapping: the grammar, the numerals and the Arabic dual form all come from
 * ICU rather than from a table anybody here maintains. What was worth keeping
 * from the wrapper is only the unit choice, which is the part below.
 */
const UNITS: ReadonlyArray<readonly [Intl.RelativeTimeFormatUnit, number]> = [
  ['year', 365 * 24 * 60 * 60],
  ['month', 30 * 24 * 60 * 60],
  ['day', 24 * 60 * 60],
  ['hour', 60 * 60],
  ['minute', 60],
  ['second', 1],
];

export function relativeTime(
  value: Date,
  locale: Locale = DEFAULT_LOCALE,
  now = new Date(),
): string {
  const seconds = Math.round((value.getTime() - now.getTime()) / 1000);
  const magnitude = Math.abs(seconds);

  const format = new Intl.RelativeTimeFormat(locale, { numeric: 'auto' });

  // The largest unit that gives a whole number greater than one — "منذ ساعة"
  // rather than "منذ ٦٠ دقيقة". `numeric: 'auto'` is what turns the smallest
  // ones into "الآن" and "أمس" instead of "منذ ٠ ثانية".
  for (const [unit, span] of UNITS) {
    if (magnitude >= span || unit === 'second') {
      return format.format(Math.round(seconds / span), unit);
    }
  }

  return format.format(0, 'second');
}
